import { CompanyBranchData } from "@/common/types/companyBranches.type"
import { CompanyBranchTransformerToStructureResponse } from "@/features/privateCompanies/types/companyBranches.type"
import { GitFork } from "lucide-react"

export class CompanyBranchesTransformer {
  static structureTransformer({ companyId }: { companyId: string }) {
    return (companyBranches: CompanyBranchData[]) => {
      const nodes = companyBranches.map((branch) => ({
        id: branch.id,
        data: { ...branch, companyId },
        type: 'custom',
        position: {
          x: 0,
          y: 0
        }
      }))

      const edges = companyBranches.filter((branch) => branch.parent_id !== companyId).map((branch) => ({
        id: `${branch.id}-${branch.parent_id}`,
        source: branch.parent_id,
        target: branch.id
      }))

      return { nodes, edges } as CompanyBranchTransformerToStructureResponse
    }
  }

  static optionsTransformer() {
    return (companyBranches: CompanyBranchData[]) => {
      return companyBranches.map((companyBranch) => {
        return {
          value: companyBranch.id,
          label: companyBranch.display_name,
          icon: <GitFork strokeWidth={1} size={20} />
        };
      });
    };
  }
}
